import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { isWorkerRole } from '../utils/roles.js';
import './ApoyosHub.css';

export default function ApoyosHub() {
    const { user } = useAuth();
    const isWorker = isWorkerRole(user?.rol);

    if (!isWorker) {
        return (
            <div className="apoyos-hub">
                <header className="apoyos-hub-header">
                    <h1>Herramientas extra</h1>
                    <p className="apoyos-hub-lead">Accesos puntuales cuando los necesites.</p>
                </header>

                <div className="apoyos-trimestre glass-card">
                    <p className="apoyos-trimestre-title">📅 Registro de manada cada trimestre</p>
                    <p className="apoyos-trimestre-text">
                        La encuesta oficial ALINEA (unos 2 minutos) se renueva cada ~3 meses. La app te la volverá a pedir
                        automáticamente; también puedes actualizarla aquí cuando quieras.
                    </p>
                </div>

                <section className="apoyos-hub-grid">
                    <NavLink to="/profile-quiz" state={{ retake: true }} className="apoyos-card apoyos-card--primary">
                        <span className="apoyos-card-emoji" aria-hidden>✏️</span>
                        <div>
                            <h2 className="apoyos-card-title">Registro de manada</h2>
                            <p className="apoyos-card-desc">Diagnóstico oficial ALINEA (como operario).</p>
                        </div>
                    </NavLink>
                    <NavLink to="/coach" className="apoyos-card">
                        <span className="apoyos-card-emoji" aria-hidden>🧭</span>
                        <div>
                            <h2 className="apoyos-card-title">Guías y seguimiento</h2>
                            <p className="apoyos-card-desc">Ideas para conversar y acompañar.</p>
                        </div>
                    </NavLink>
                    <NavLink to="/observador" className="apoyos-card">
                        <span className="apoyos-card-emoji" aria-hidden>🔎</span>
                        <div>
                            <h2 className="apoyos-card-title">Observador</h2>
                            <p className="apoyos-card-desc">Tu pausa consciente como parte de la manada.</p>
                        </div>
                    </NavLink>
                </section>
                <p className="apoyos-hub-foot">
                    <NavLink to="/" className="apoyos-back">← Volver a tu equipo</NavLink>
                </p>
            </div>
        );
    }

    return (
        <div className="apoyos-hub apoyos-hub--worker">
            <header className="apoyos-hub-header">
                <h1>Actualizar tu perfil</h1>
                <p className="apoyos-hub-lead">
                    Tu día a día está en <strong>Jornada</strong> (llegada, pausas y cierre). Aquí solo vuelves a hacer el{' '}
                    <strong>Registro de manada</strong> cuando toque renovarlo.
                </p>
            </header>

            <div className="apoyos-trimestre glass-card">
                <p className="apoyos-trimestre-title">📅 Recomendación cada trimestre</p>
                <p className="apoyos-trimestre-text">
                    Vuelve a completar el registro unas 4 veces al año (cada ~3 meses) o cuando cambie mucho tu rol, turno o
                    equipo. Usa siempre la misma encuesta oficial ALINEA: tarda unos 2 minutos y no es una evaluación frente a tu
                    jefe.
                </p>
            </div>

            <NavLink to="/profile-quiz" state={{ retake: true }} className="apoyos-card apoyos-card--primary">
                <span className="apoyos-card-emoji" aria-hidden>✏️</span>
                <div>
                    <h2 className="apoyos-card-title">Registro de manada</h2>
                    <p className="apoyos-card-desc">Actualizar radar de preferencias (plantilla ALINEA).</p>
                </div>
            </NavLink>

            <p className="apoyos-hub-foot">
                <NavLink to="/" className="apoyos-back">
                    ← Volver a Jornada
                </NavLink>
            </p>
        </div>
    );
}
